(function (app) {

    app.provider("eventTypeApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.get = function (eventTypeId) {
                            return marketingTrackerApiGateway.get("/EventTypes/" + eventTypeId);
                        };

                        service.getEventTypes = function () {
                            return marketingTrackerApiGateway.get("/EventTypes");
                        };

                        service.getUserEventTypes = function(userId) {
                            return marketingTrackerApiGateway.get("/EventTypes/User/" + userId);
                        };

                        service.update = function (eventTypeId, eventType) {
                            return marketingTrackerApiGateway.put("/EventTypes/" + eventTypeId, eventType);
                        };

                        service.create = function (eventType) {
                            return marketingTrackerApiGateway.post("/EventTypes", eventType);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line